import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Link } from 'react-router-dom';

import {
  Cookie,
  X
} from '@phosphor-icons/react';
const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    const preferences = {
      essential: true,
      analytics: true,
      marketing: true,
      personalization: true
    };
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleDeclineNonEssential = () => {
    const preferences = {
      essential: true,
      analytics: false,
      marketing: false,
      personalization: false
    };
    localStorage.setItem('cookieConsent', 'partial');
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleCustomize = () => {
    // Redirect to cookie settings page
    window.location.href = '/cookie-settings';
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-7xl mx-auto">
            <div className="glass rounded-2xl p-6 md:p-8 shadow-2xl border border-[rgba(255,255,255,0.1)]">
              <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="p-3 rounded-full bg-[#00E5C0]">
                      <Cookie size={24} className="text-white" />
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-white mb-2">
                    We Value Your Privacy
                  </h3>
                  <p className="text-[#E2E8F0] text-sm leading-relaxed">
                    We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                    By clicking "Accept", you consent to our use of cookies. You can learn more about how we handle 
                    your data in our{' '}
                    <Link 
                      to="/privacy" 
                      className="text-[#818CF8] hover:text-[#A5B4FC] underline transition-colors font-medium"
                    >
                      Privacy Policy
                    </Link>.
                  </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto flex-shrink-0">
                  <button
                    onClick={handleDeclineNonEssential}
                    className="px-5 py-2.5 rounded-lg border border-[rgba(255,255,255,0.2)] text-[#A0AEC0] hover:text-white hover:bg-[rgba(255,255,255,0.05)] transition-all text-sm font-medium"
                  >
                    Decline Non-Essential
                  </button>
                  <button
                    onClick={handleCustomize}
                    className="px-5 py-2.5 rounded-lg border border-[rgba(255,255,255,0.2)] text-white hover:bg-[rgba(255,255,255,0.05)] transition-all text-sm font-medium"
                  >
                    Customize
                  </button>
                  <button
                    onClick={handleAcceptAll}
                    className="rounded-lg px-6 py-2.5 bg-[#00E5C0] hover:bg-[#00D4B0] transition-colors"
                  >
                    <span className="text-white font-medium text-sm">
                      Accept All Cookies
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
